import React, { Component } from 'react';

import { RelatedEntityGrid as EntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import UsuarioPin        from '../../../models/UsuarioPin';
import { Usuario } from 'hay-core-react';
import UsuarioPinTipoEnum      from '../../../enums/UsuarioPinTipoEnum';
import UsuarioPinTipoEnvioEnum from '../../../enums/UsuarioPinTipoEnvioEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    usuario: {
        exibir:       'main.usuariopin.usuario',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'usuario.entidade',
        template:     'usuario.template',
    },
    tipo: {
        exibir:   'main.usuariopin.tipo',
        visivel:  true,
        tipo:     'enum',
        entidade: 'usuariopin.tipo',
    },
    tipoenvio: {
        exibir:   'main.usuariopin.tipoenvio',
        visivel:  true,
        tipo:     'enum',
        entidade: 'usuariopin.tipoenvio',
    },
    pin:             { exibir: 'main.usuariopin.pin', visivel: true },
    datautilizacao:  { exibir: 'main.usuariopin.datautilizacao', visivel: true, tipo: 'date', time: true },
    tempovalidade:   { exibir: 'main.usuariopin.tempovalidade', tipo: 'numeric' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    usuario: { entidade: Usuario, template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '' },
    'usuariopin.tipo':      UsuarioPinTipoEnum,
    'usuariopin.tipoenvio': UsuarioPinTipoEnvioEnum,
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class UsuarioPinFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.usuario} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.tipo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.tipoenvio} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.pin} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={model.datautilizacao} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelInputNumber model={model.tempovalidade} contexto={contexto} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class UsuarioPinTemplate extends Component {
    render() {
        return (
            <EntityGrid
                entidade={UsuarioPin}
                model={model}
                identidade="main.usuariopin"
                permissoes={this.props.permissoes}
                icone="pi-key"
                storageKey="dt-usuariopins"
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                ordenacaoPadrao={{ sortField: 'createdAt', sortOrder: -1 }}
                formulario={(m, ctx) => <UsuarioPinFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default UsuarioPinTemplate;
